export default __webpack_public_path__ + "static/media/22.a0b57fd6.jpg";